import { DefaultTheme } from '../../components/theme';
import { ColorPalette2022Branding } from '../../components/theme.palette';

export const CSS = {
	container: 'c-TagIcon',
	bareContainer: 'c-TagIcon--bare',
	redDot: 'c-TagIcon__RedDot',
};

/** Width of the CSS border drawn around the circle — subtracted from the container's outer size when
 *  sizing the inner asset-type ring (see `ASSET_TYPE_MARKER_DIAMETER` in `tag.icon.ts`), since the ring
 *  is centered in the content box, not the bordered outer box. */
export const TAG_ICON_BORDER_WIDTH = 2;

export const Style = {
	[CSS.container]: {
		width: 'inherit',
		height: 'inherit',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'box-sizing': 'border-box',
		fontFamily: DefaultTheme.font.familyCondensed,
		fontWeight: DefaultTheme.font.weight.bold,
		boxShadow: DefaultTheme.shadow.box.dp2,
		color: DefaultTheme.font.color.primary,
		border: `${TAG_ICON_BORDER_WIDTH}px solid`,
		position: 'relative',
		// Without these, a click here can land as the browser's native text-selection instead of a plain
		// click (the number/icon inside is literal text/icon-font content) — same reasoning `.c-CheckBox`
		// itself already sets `userSelect`/`cursor` for. That swallowed click is why hovering+clicking this
		// spot didn't reliably swap into the checkbox underneath and select the row.
		userSelect: 'none',
		cursor: 'pointer',
	},
	// No border/background/box-shadow — an asset-type collection shows just its bare icon, not a dot.
	[CSS.bareContainer]: {
		width: 'inherit',
		height: 'inherit',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
		userSelect: 'none',
		cursor: 'pointer',
	},
	[CSS.redDot]: {
		position: 'absolute',
		top: '-2px',
		right: '-2px',
		width: '6px',
		height: '6px',
		'border-radius': '50%',
		'background-color': ColorPalette2022Branding.lightRed,
		border: '1px solid #FFFFFF',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'pointer-events': 'none',
	},
};
